// extracted by mini-css-extract-plugin
export var actionButton = "_qj-0";
export var actionMenuContainer = "_qj-i";
export var bubble = "_qj-2";
export var bubbleActionMenu = "_qj-j";
export var bubbleContext = "_qj-6";
export var bubbleItems = "_qj-7";
export var customer = "_qj-3";
export var divider = "_qj-8";
export var fileList = "_qj-9";
export var hiddenComment = "_qj-o";
export var infoAbove = "_qj-a";
export var internal = "_qj-4";
export var lightActionButton = "_qj-1";
export var link = "_qj-b";
export var merchant = "_qj-5";
export var message = "_qj-c";
export var profilePicture = "_qj-e";
export var quillToolbarContainer = "_qj-f";
export var senderDate = "_qj-g";
export var senderDateCustomer = "_qj-h";
export var senderName = "_qj-d";
export var time = "_qj-k";
export var uploadedImage = "_qj-l";
export var username = "_qj-m";
export var xsmall = "_qj-n";